import { AppState } from 'store/root.reducer'

export const selectDadataState = (state: AppState) => state?.dadata

export const selectDataFio = (state: AppState) => selectDadataState(state)?.dataFio

export const selectLoadingGetFioStatus = (state: AppState) => selectDadataState(state)?.loadingGetFio
